import { WidgetType } from "./widgetTypes";
import { Category } from "./categories";

export const createLabValueConfig = ({ key, units = [], defaultUnit = "", fieldInStandardUnit }) => {
    const hasConversion = !!fieldInStandardUnit;
    const valueField = hasConversion ? "labs.value_in_standard_unit" : "labs.value";

    return {
        ["labs-" + key]: {
            widgetType: WidgetType.NESTED,
            category: Category.LABORATORY,
            widgetConfig: {
                label: "laboratory.timeline." + key,
            },
            defaultRuleProperties: {
                exclude: false,
                nestedPath: "labs",
                value: {
                    type: "nested",
                    nestedValues: [
                        {
                            type: "rule",
                            properties: {
                                field: valueField,
                                operator: "gte",
                                value: "",
                                labName: key,
                            },
                        },
                        ...(units?.length > 1
                            ? [
                                  {
                                      type: "rule",
                                      properties: {
                                          field: "labs." + key + "_unit",
                                          virtualField: true,
                                          value: defaultUnit,
                                          labName: key,
                                      },
                                  },
                              ]
                            : []),
                        {
                            type: "rule",
                            properties: {
                                field: "labs.is_latest",
                                value: "",
                                labName: key,
                            },
                        },
                    ],
                },
            },
        },
        [valueField]: {
            widgetType: WidgetType.SIMPLE_NUMBER,
            widgetConfig: {
                label: "",
                width: 100,
                operators: ["eq", "gt", "lt", "gte", "lte"],
            },
        },
        ["labs." + key + "_unit"]: {
            widgetType: WidgetType.DROPDOWN,
            widgetConfig: {
                label: "",
                values: units,
            },
        },
        ["labs.is_latest"]: {
            widgetType: WidgetType.DROPDOWN,
            widgetConfig: {
                label: "cohort.latest-only-lab-entry",
                width: 130,
                values: [
                    { value: true, label: "global.yes" },
                    { value: false, label: "global.no" },
                ],
            },
        },
    };
};
